import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { type CompleteRegistrationEvent } from '../types/base/meta-pixel-events'
import { type KlaviyoSignUpEvent } from '../types/klaviyoEvents'
import { type DniAnalysisTransformer } from './transformers'

export const signUpTransformer: DniAnalysisTransformer = (platform, event) => {
  if (event.eventName !== 'sign_up') return event
  const { meta, ...eventParamsWithoutMeta } = event.eventParams
  const { country_code, account_type } = meta || {}
  const { method, user_id } = eventParamsWithoutMeta

  if (platform === AnalyticsPlatforms.META_PIXEL) {
    const event: CompleteRegistrationEvent = {
      eventName: 'CompleteRegistration',
      eventParams: {},
      eventId: user_id,
    }
    return event
  }
  if (platform === AnalyticsPlatforms.KLAVIYO) {
    const event: KlaviyoSignUpEvent = {
      eventName: 'signup_success',
      eventParams: {
        $event_id: user_id,
        user_id,
        method,
        country_code,
        account_type,
      },
    }
    return event
  }
  return {
    ...event,
    eventParams: eventParamsWithoutMeta,
  }
}
